<template>
  <div class="bluefire-wap-wrap">
    <wap-header header-text="消息管理" :header-visible="true" :back-visible="true" /><!--参数都可以不传-->
    <scroll-refresh>
      <div class="message-wrap">
        <div class="search-area">
          <div class="search-content">
            <el-select placeholder="消息类型" v-model="searchData.ntype" @change="searchMessage">
              <el-option
                label="全部"
                value=""
              />
              <el-option
                v-for="(item, key) in options[msg[tabCheck]]"
                :key="key"
                :label="item"
                :value="key"
              />
            </el-select>
            <i></i>
            <el-input placeholder="学生昵称/CRMID" v-model="searchData.dd_nickname" @change="searchMessageByName"></el-input>
          </div>
        </div>
        <div class="tab-area">
          <div class="btn-allread" v-if="$hasPermission([1, 22, 33, 36, 39, 42, 51, 101, 121, 122, 142, 148])">
            <el-button type="primary" round size="small" @click="setReadAll">全标已读</el-button>
          </div>
          <el-button @click="tabClick('0')" :class="tabCheck === '0' ? 'active' : ''">状态提醒<i v-show="count.status_message">{{ count.status_message }}</i></el-button>
          <el-button @click="tabClick('1')" :class="tabCheck === '1' ? 'active' : ''">支付消息<i v-show="count.payment_message">{{ count.payment_message }}</i></el-button>
          <el-button @click="tabClick('3')" :class="tabCheck === '3' ? 'active' : ''">问答消息<i v-show="count.question_message">{{ count.question_message }}</i></el-button>
          <el-button @click="tabClick('4')" :class="tabCheck === '4' ? 'active' : ''">VIP权益消息<i v-show="count.behaviour_message">{{ count.behaviour_message }}</i></el-button>
          <el-button @click="tabClick('5')" :class="tabCheck === '5' ? 'active' : ''">VIP咨询消息<i v-show="count.consult_message">{{ count.consult_message }}</i></el-button>
        </div>
        <div class="list-area">
          <data-list :url="url"
                     :search-data="searchData"
                     :refresh.sync="refresh">
            <template slot-scope="{ item }">
              <div class="list-content">
                <div class="title-area">{{ item.addtime }}</div>
                <div class="content-area" @click="initClick(item)">
                  <h3>{{ item.ntype }}<i :class="item.status > 1 ? '' : 'red-color'">{{ item.status > 1 ? '已读' : '未读' }}</i></h3><!--未读时i标签增加red-color-->
                  <div class="tip-area">
                    <div><span>昵称</span><span>{{ item.custom_nickname_tell }}</span></div>
                    <div>
                      <span>学生CRM_ID</span>
                      <span>{{ item.crm_id }}</span>
                    </div>
                  </div>
                  <div class="text-area">
                    <h3>消息内容</h3>
                    <p><i></i>{{ item.content }}</p>
                  </div>
                </div>
              </div>
            </template>
          </data-list>
        </div>
      </div>
    </scroll-refresh>
  </div>
</template>
<script>
import header from './compoments/header';
import scrollRefresh from './compoments/scrollRefresh';
import DataList from './compoments/dataList';
import router from '@/router';

const searchData = {
  ntype: '',
  dd_nickname: '',
  type: 'status_message'
};

export default {
  data() {
    return {
      msg: [
        'status_message',
        'payment_message',
        'task_message',
        'question_message',
        'behaviour_message',
        'consult_message'
      ],
      options: {
        status_message: {},
        payment_message: {},
        task_message: {},
        question_message: {},
        behaviour_message: {},
        consult_message: {}
      },
      count: {
        status_message: 0,
        payment_message: 0,
        task_message: 0,
        question_message: 0,
        behaviour_message: 0,
        consult_message: 0,
      },
      tabCheck: '0',
      listUrl: '',
      searchData: {},
      refresh: false,
    };
  },
  computed: {
    typeInterface() {
      if (this.tabCheck === '2') {
        return 'planMessage';
      } else if (this.tabCheck === '0' || this.tabCheck === '1') {
        return 'remindStudent';
      } else if (this.tabCheck === '3') {
        return 'remindQuestion';
      } else if (this.tabCheck === '4') {
        return 'userActiveVip';
      } else if (this.tabCheck === '5') {
        return 'userConsultVip';
      }
    },
    url() {
      return `/index/system/${this.typeInterface}`;
    }
  },
  methods: {
    // tab点击
    tabClick: function(val) {
      this.tabCheck = val;
      this.setSearchData();
      this.searchData.type = this.msg[val];
      this.refresh = true;
    },
    setSearchData() {
      this.searchData = Object.assign({}, searchData);
    },
    searchMessage() {
      this.refresh = true;
    },
    searchMessageByName() {
      this.refresh = true;
    },
    fetchCount() {
      return this.$http
        ._get({
          url: '/index/system/noRead'
        })
        .then(({ data }) => {
          this.count = data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    read(id, status) {
      this.$http
        ._post({
          url: '/index/system/setRemindStatus',
          data: { id: id, status: status, type: 'remindStudent' }
        })
        .then(() => {
          this.refresh = true;
          this.$message.success('修改成功');
        });
    },
    // 消息跳转方法转换
    initClick(item) {
      if (item.status !== 2) {
        this.read(item.id, item.status);
      }
      router.replace({ name: 'h5User', params: { crmid: item.crm_id } });
    },
    // 设置全部已读
    setReadAll() {
      this.$http
        ._post({
          url: '/index/system/remindLeaderRead',
        })
        .then(() => {
          this.$message.success('全部已读设置成功');
          this.fetchCount();
          this.refresh = true;
        });
    }
  },
  watch: {},
  mounted() {
    this.setSearchData();
    this.$http
      ._get({
        url: '/index/system/remindInterface'
      })
      .then(({ data }) => {
        this.options.status_message = data.status;
        this.options.payment_message = data.payment;
        this.options.question_message = data.question;
        this.options.behaviour_message = data.behaviour;
        this.options.consult_message = data.consult;
      });
    this.fetchCount();
    this.searchMessage();
  },
  components: {
    'wap-header': header,
    DataList,
    scrollRefresh
  }
};
</script>
<style>
  .bluefire-wap-wrap .message-wrap .search-area .search-content .el-input__inner{
    background: none;
    border: none;
  }
  .message-wrap .infinite-list-wrapper ul li{
    background: none;
    padding: 0;
    margin-bottom: 0;
  }
</style>
<style scoped>
  .message-wrap .search-area{
    background: #fff;
    padding: 0 4vw;
  }
  .message-wrap .search-area .search-content{
    background: #f8f8f8;
    border-radius: 1vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 10.6vw;
    line-height: 10.6vw;
  }
  .message-wrap .search-area .search-content .el-select{
    width: 42vw;
  }
  .message-wrap .search-area .search-content > i{
    display: inline-block;
    height: 3.73vw;
    width: 1px;
    background: #9A9A9A;
  }
  .message-wrap .tab-area{
    background: #fff;
    height: 13.8vw;
    line-height: 13.8vw;
    padding: 0 4vw;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
  }
  .message-wrap .tab-area .btn-allread{
    display: inline-block;
    vertical-align: middle;
    line-height: normal;
    font-size: 0;
    padding:0 3vw 0 4vw;
    margin-right: 3vw;
    border-right: 1px solid #dedede;
    background: url(../../assets/wap/icon-allread1.png) no-repeat left center;
    background-size: auto 3.5vw;
  }
  .message-wrap .tab-area .btn-allread:active{
    background: url(../../assets/wap/icon-allread2.png) no-repeat left center;
    background-size: auto 100%;
  }
  .message-wrap .tab-area .btn-allread .el-button{
    color: #666;
  }
  .message-wrap .tab-area .btn-allread:active .el-button{
    color: #0496ff;
  }
  .message-wrap .tab-area .el-button{
    border: none;
    background: none;
    padding: 0;
    margin-right: 3vw;
    position: relative;
    font-size: 3.46vw;
    vertical-align: middle;
    color: #333;
  }
  .message-wrap .tab-area .el-button.active{
    color: #0496ff;
  }
  .message-wrap .tab-area .el-button:last-of-type{
    margin-right: 0;
  }
  .message-wrap .tab-area .el-button i{
    position: absolute;
    font-size: 3.2vw;
    color: #fff;
    height: 4.26vw;
    line-height: 4.26vw;
    white-space: nowrap;
    background: #ff3a3a;
    border-radius: 2.13vw;
    padding: 0 1.3vw;
    z-index: 2;
    left: 90%;
    bottom: 75%;
  }
  .message-wrap .list-area .list-content{
    clear: both;
    font-size: 0;
  }
  .message-wrap .list-area .list-content .title-area{
    height: 12.2vw;
    line-height: 12.2vw;
    font-size: 3.46vw;
    color: #9a9a9a;
    background: #f5f5f5;
    text-align: center;
  }
  .message-wrap .list-area .list-content .content-area{
    border-radius: 2vw;
    background: #fff;
    padding: 5vw 4vw;
  }
  .message-wrap .list-area .list-content .content-area > h3{
    font-size: 4.8vw;
    position: relative;
    padding-right: 6vw;
  }
  .message-wrap .list-area .list-content .content-area > h3 i{
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    font-size: 3.73vw;
    color: #c4c4c4;
    font-weight: normal;
  }
  .message-wrap .list-area .list-content .content-area > h3 i.red-color{
    color: #FF3A3A;
  }
  .message-wrap .list-area .list-content .content-area .tip-area{
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    padding-top: 1vw;
  }
  .message-wrap .list-area .list-content .content-area .tip-area > div{
    padding-right: 4vw;
  }
  .message-wrap .list-area .list-content .content-area .tip-area span{
    display: inline-block;
    font-size: 3.73vw;
    line-height: 6vw;
  }
  .message-wrap .list-area .list-content .content-area .tip-area span:first-of-type{
    color: #888;
    margin-right: 1.4vw;
  }
  .message-wrap .list-area .list-content .content-area .text-area{
    padding-top: 3vw;
  }
  .message-wrap .list-area .list-content .content-area .text-area h3{
    font-size: 4vw;
    color: #8F99BF;
    font-weight: normal;
  }
  .message-wrap .list-area .list-content .content-area .text-area p{
    border-radius: 1.6vw;
    background: #F1F5FC;
    padding: 3vw 4vw;
    position: relative;
    font-size: 3.73vw;
    color: #8F99BF;
    line-height: 6vw;
    margin-top: 3vw;
  }
  .message-wrap .list-area .list-content .content-area .text-area p i{
    position: absolute;
    top: -2.5vw;
    left: 6vw;
    border-bottom: 2.6vw solid #f1f5fc;
    border-left: 1.86vw solid transparent;
    border-right: 1.86vw solid transparent;
  }
</style>
